import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import * as React from "react";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#0947AB" : "#308fe8",
  },
}));

const CustomizedProgressBars = ({ value, className }) => {
  return (
    <Box
      sx={{ flexGrow: 1 }}
      className={`flex items-center justify-center ${className}`}
    >
      <BorderLinearProgress
        className="w-full"
        variant="determinate"
        value={value}
      />
    </Box>
  );
};

CustomizedProgressBars.propTypes = {
  className: PropTypes.any,
  value: PropTypes.any,
};
export default CustomizedProgressBars;
